import * as z from 'zod';

export const tcCategoryQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type TcCategoryQueryLinkerSchema = z.infer<typeof tcCategoryQueryLinkerSchema>;
